import { InfoCircle } from 'iconsax-react';
import { useTranslation } from 'next-i18next';

import Close from '@/assets/icons/Close';
import IconButton from '@/components/IconButton';
import useMaintenanceBar from '@/components/MaintananceBar/hooks';
import MarkdownText from '@/components/MarkdownText';
import classNames from '@/helpers/classNames';

import styles from './MaintenanceBar.module.scss';

export default function MaintenanceBar() {
  const { t } = useTranslation('common');
  const { data, isClosed, isPending, onClose } = useMaintenanceBar();

  if (isClosed || isPending || !data) {
    return null;
  }

  return (
    <div className={classNames([styles.container, styles[data.type]])}>
      <InfoCircle variant="Linear" color="currentColor" size={24} className={styles.icon} />
      <div className={styles.content}>
        <p className={styles.header}>{data.title ?? t('planned-maintenance')}</p>
        <MarkdownText className={styles.message}>{data.message}</MarkdownText>
      </div>
      <IconButton
        Icon={Close}
        variant="transparent"
        size="extraSmall"
        iconSize={24}
        type="button"
        className={styles.closeButton}
        onClick={onClose}
      />
    </div>
  );
}
